angular.module 'zc.projects'

.config ($stateProvider) ->

  $stateProvider
  .state 'admin.projects.segments',
    url: '/segments'
    views:
      'content@':
        templateUrl: '/templates/projects.segments/list.html'
        controller: 'SegmentListCtrl'

  .state 'admin.projects.segments.new',
    url: '/new/:segmentType'
    views:
      'content@':
        templateUrl: '/templates/projects.segments/edit.html'
        controller: 'SegmentEditCtrl'
        resolve:
          segment: ($stateParams) ->
            segment = {
              project_id: $stateParams.projectId
              segment_type: $stateParams.segmentType
              name: ""
              description: ""
              raw: "{}"
              json: "{}"
              conditions_json: {}
            }

            if $stateParams.segmentType == 'inactive'
              segment.conditions_json = { days_since_last_conversion: 30 }

            segment.conditions_json.history_back_trigger_option = 'any_domain'
            segment


  .state 'admin.projects.segments.show',
    url: '/{segmentId:int}'
    views:
      'content@':
        templateUrl: '/templates/projects.segments/show.html'
        controller: 'SegmentShowCtrl'
        resolve:
          segment: (CampaignSegment, $stateParams, currentProject) ->
            CampaignSegment.get(currentProject.id, $stateParams.segmentId)

  .state 'admin.projects.segments.edit',
    url: '/{segmentId:int}/edit'
    views:
      'content@':
        templateUrl: '/templates/projects.segments/edit.html'
        controller: 'SegmentEditCtrl'
        resolve:
          segment: (CampaignSegment, $stateParams, currentProject) ->
            CampaignSegment.get(currentProject.id, $stateParams.segmentId)




// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.segments/routes.coffee